import React from 'react';
import cx from 'classnames';
import { Card } from 'react-bootstrap';
import styles from './Style.module.scss';
import Truncate from 'src/components/truncate';

class UserGroupOptionView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
    }

    this._handleOptionSelected = this._handleOptionSelected.bind(this);
  }

  _handleOptionSelected() {
    if (this.props.setValue) {
      this.props.setValue(this.props.children.props);
    }
  }

  render() {
    return (
      <div
        className={cx(styles.option, { [styles.focus]: this.props.isFocused })}
      >
        {this.renderOption(this.props.children.props.option)}
      </div>
    );
  }

  renderOption(option) {
    return this.renderUserGroup(option.value);
  }

  renderUserGroup(userGroup) {
    return (
      <div
        key={userGroup.id}
        className={cx(styles.userGroup, styles.border)}
        onClick={() => this._handleOptionSelected(userGroup)}
      >
        <div className={styles.left}>
          <div className={styles.groupAvatar}>
            {" "}
            {this.renderInitials(userGroup)}{" "}
          </div>
        </div>
        <div className={styles.body}>
          <div className={styles.groupName}>
            <Truncate lines={1}> {this.renderName(userGroup)} </Truncate>
          </div>
        </div>
      </div>
    );
  }

  renderName(userGroup) {
    return `${userGroup.name || ""}`;
  }

  renderInitials(userGroup) {
    let initial = "";

    if (userGroup.name) {
      initial = userGroup.name.charAt(0);
    }
    return initial.toUpperCase();
  }
}

export default UserGroupOptionView;